import { axios } from 'src/api'

export interface ApiMarkNotificationsAsReadParams {
  serverPath: string
  data:{
    userToken: string
    notificationList: string[]
  }
}

export const apiMarkNotificationsAsRead = ({ serverPath, data }:ApiMarkNotificationsAsReadParams) => {
  return axios.post<{ok: boolean}>(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/webcrossorigin/marknotificationasread`, data)
}
